import { IGetEmailsResponse } from "../../../interfaces/api/IEmails";
import { IDeleteMaillingRuleDocumentQuery, IDeleteMaillingRuleProductQuery, IDeleteMaillingRuleTemplateQuery, IGetMaillingRuleDocumentsResponse, IGetMaillingRuleProductsResponse, IGetMaillingRulesQuery, IGetMaillingRulesResponse, IGetMaillingRuleTemplatesResponse, IMaillingRule, IPostMaillingRuleDocumentQuery, IPostMaillingRuleProductQuery, IPostMaillingRuleQuery, IPostMaillingRuleTemplateQuery, IPutMaillingRuleQuery, IPostMaillingRuleResponse, IPutMaillingRuleDocumentsQuery } from "../../../interfaces/api/IMaillingRules";
import { IGetWithUuidQuery, IMessageResponse} from "../../../interfaces/api/IQueries";
import { api } from "../api";

/**
 * it adds the mailling rules endpoint to the api
 * 
 * @returns MaillingRuleRepository
 */
const MaillingRuleRepository = api.injectEndpoints({
    endpoints: (build) => ({
        getMaillingRules: build.query<IGetMaillingRulesResponse|IMessageResponse, IGetMaillingRulesQuery>({
            query: (queryParameters) =>{
                const {page, per_page, name, status, date_start, date_end} = queryParameters;
                let url = `/maillingRules?page=${page}&per_page=${per_page}`;
                if(name !== "") {
                    url += `&name=${name}`;
                }
                if(status !== "all") {
                    url += `&status=${status}`;
                }
                if(date_start !== "") {
                    url += `&date_start=${date_start}`;
                }
                if(date_end !== "") {
                    url += `&date_end=${date_end}`;
                }

                return({url: url, method: "GET"});
            },          
        }),
        postMaillingRule: build.mutation<IPostMaillingRuleResponse|IMessageResponse, IPostMaillingRuleQuery>({
            query: (data) => ({url: "/maillingRules", method: "POST", data}),
        }),
        getOneMaillingRule: build.query<IMaillingRule|IMessageResponse, IGetWithUuidQuery>({
            query: ({uuid}) => ({url: `/maillingRules/${uuid}`, method: "GET"}),
        }),
        putOneMaillingRule: build.mutation<IMessageResponse, IPutMaillingRuleQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}`, method: "PUT", data}),
        }),
        postTestMaillingRule: build.mutation<IMessageResponse, IGetWithUuidQuery>({
            query: ({uuid}) => ({url: `/maillingRules/${uuid}/test`, method: "POST"}),
        }),
        //Documents 
        getMaillingRuleDocuments: build.query<IGetMaillingRuleDocumentsResponse|IMessageResponse, IGetWithUuidQuery>({
            query: ({uuid}) => ({url: `/maillingRules/${uuid}/documents`, method: "GET"}),          
        }),
        postMaillingRuleDocument: build.mutation<IMessageResponse, IPostMaillingRuleDocumentQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}/documents`, method: "POST", data}),
        }),
        putMaillingRuleDocuments: build.mutation<IMessageResponse, IPutMaillingRuleDocumentsQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}/documents`, method: "PUT", data}),
        }),
        deleteMaillingRuleDocument: build.mutation<IMessageResponse, IDeleteMaillingRuleDocumentQuery>({
            query: ({uuid, document_uuid}) => ({url: `/maillingRules/${uuid}/documents/${document_uuid}`, method: "DELETE"}),
        }),
        //Products
        getMaillingRuleProducts: build.query<IGetMaillingRuleProductsResponse|IMessageResponse, IGetWithUuidQuery>({
            query: ({uuid}) => ({url: `/maillingRules/${uuid}/products`, method: "GET"}),          
        }),
        postMaillingRuleProduct: build.mutation<IMessageResponse, IPostMaillingRuleProductQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}/products`, method: "POST", data}),
        }),
        putMaillingRuleProducts: build.mutation<IMessageResponse, IPostMaillingRuleProductQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}/products`, method: "PUT", data}),
        }),
        deleteMaillingRuleProduct: build.mutation<IMessageResponse, IDeleteMaillingRuleProductQuery>({
            query: ({uuid, product_uuid}) => ({url: `/maillingRules/${uuid}/products/${product_uuid}`, method: "DELETE"}),
        }),
        //Templates
        getMaillingRuleTemplates: build.query<IGetMaillingRuleTemplatesResponse|IMessageResponse, IGetWithUuidQuery>({
            query: ({uuid}) => ({url: `/maillingRules/${uuid}/templates`, method: "GET"}),          
        }),
        postMaillingRuleTemplate: build.mutation<IMessageResponse, IPostMaillingRuleTemplateQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}/templates`, method: "POST", data}),
        }),
        putMaillingRulesTemplates: build.mutation<IMessageResponse, IPostMaillingRuleTemplateQuery>({
            query: ({uuid, data}) => ({url: `/maillingRules/${uuid}/templates`, method: "PUT", data}),
        }),
        deleteMaillingRuleTemplate: build.mutation<IMessageResponse, IDeleteMaillingRuleTemplateQuery>({
            query: ({uuid, template_uuid}) => ({url: `/maillingRules/${uuid}/templates/${template_uuid}`, method: "DELETE"}),
        }),
        //Mails
        getMaillingRuleMails: build.query<IGetEmailsResponse|IMessageResponse, IGetWithUuidQuery>({
            query: ({uuid}) => ({url: `/maillingRules/${uuid}/mails`, method: "GET"}),          
        }),
    }),
});

export const {
    useGetMaillingRulesQuery,
    usePostMaillingRuleMutation,
    useGetOneMaillingRuleQuery,
    usePutOneMaillingRuleMutation,
    usePostTestMaillingRuleMutation,
    useGetMaillingRuleDocumentsQuery,
    usePostMaillingRuleDocumentMutation,
    usePutMaillingRuleDocumentsMutation,
    useDeleteMaillingRuleDocumentMutation,
    useGetMaillingRuleProductsQuery,
    usePostMaillingRuleProductMutation,
    usePutMaillingRuleProductsMutation,
    useDeleteMaillingRuleProductMutation,
    useGetMaillingRuleTemplatesQuery,
    usePostMaillingRuleTemplateMutation,
    usePutMaillingRulesTemplatesMutation,
    useDeleteMaillingRuleTemplateMutation,
    useGetMaillingRuleMailsQuery
  } = MaillingRuleRepository;